module.exports = __webpack_public_path__ + "img/zaehlerfreunde-with-text.f823cf54.svg";